import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import './UserStaffStamp.scss';

class UserStaffStamp extends React.PureComponent {
  render() {
    const { className, inverse } = this.props;

    return (
      <span className={cn('cp-user-staff-stamp', className, { inverse })}>
        <FormattedMessage id="library_staff" />
      </span>
    );
  }
}

UserStaffStamp.propTypes = {
  inverse: PropTypes.bool,
  className: PropTypes.string
};

export default UserStaffStamp;
